module.exports = __webpack_public_path__ + "img/blocked-icon.616d93b5.svg";